// 9fbef606107a605d69c0edbcd8029e5d
import { ORDERDETAILS_ACTION_PATTERN } from '../../../../constants/reducer.constants';

const ORDERDETAILS_CONSTANTS = {
  GET_ORDERDETAILS: `${ORDERDETAILS_ACTION_PATTERN}GET_ORDERDETAILS`,
  SET_ORDERDETAILS: `${ORDERDETAILS_ACTION_PATTERN}SET_ORDERDETAILS`,
  SET_RECENT_ORDERDETAILS: `${ORDERDETAILS_ACTION_PATTERN}SET_RECENT_ORDERDETAILS`,
  SHOW_LOADER: `${ORDERDETAILS_ACTION_PATTERN}SHOW_LOADER`,
  HIDE_LOADER: `${ORDERDETAILS_ACTION_PATTERN}HIDE_LOADER`,
  SET_ORDER_DETAILS_ERROR: 'SET_ORDER_DETAILS_ERROR',
  RESEND_ORDER_CONFIRMATION_MODAL: 'RESEND_ORDER_CONFIRMATION_MODAL',
  STATUS_CONSTANTS: {
    IN_PROCESS: 'in process',
    ORDER_SHIPPED: 'order shipped',
    PARTIALLY_SHIPPED: 'partially shipped',
    ORDER_PICKED: 'order picked',
    ORDER_RECEIVED: 'order received',
    ORDER_IN_PROCESS: 'order in process',
    ORDER_PARTIALLY_SHIPPED: 'partially shipped',
    ORDER_CANCELED: 'canceled',
    ORDER_CANCELLED: 'cancelled',
    ITEMS_RECEIVED: 'received',
    ITEMS_READY_FOR_PICKUP: 'ready for pickup',
    ITEMS_PICKED_UP: 'picked up',
    ORDER_PICKED_UP: 'order picked up',
    EXPIRED: 'order expired',
    CANCELLED: 'order cancelled',
    SUCCESSFULLY_PICKED_UP: 'successfully picked up',
    ORDER_EXPIRED: 'expired',
    ORDER_PROCESSING: 'processing',
    NA: 'N/A',
    ORDER_USER_CALL_NEEDED: 'call needed',
    ORDER_CONTACT_CUSTOMER_SERVICE: 'please contact our customer service',
    ORDER_PROCESSING_AT_FACILITY: 'order processing at facility',
    EXPIRED_AND_REFUNDED: 'expired and refunded',
    TOP_PREVIEW_ITEMS_COUNT: 3,
    LBL_NA: 'lbl_orders_statusNa',
    LBL_CallNeeded: 'lbl_orders_statusUserCallNeeded',
    ORDER_RECEIVED_LABEL: 'lbl_orders_statusOrderReceived',
    ORDER_PREPARING: 'preparing order',
    PROCESSING: 'processing',
    PREPARING_YOUR_ORDER: 'preparing your order',
    PICKUP_EXPIRED: 'pickup expired',
    PICKUP_ITEM_EXPIRED: 'expired',
    SHIPPED: 'shipped',
    DELIVERED: 'delivered',
    CALL_NEEDED: 'call needed',
    IN_TRANSIT: 'in transit',
    OUT_FOR_DELIVERY: 'out for delivery',
    ITEM_READY_FOR_PICK_UP: 'ready for pick up',
    RETURN: 'return',
    ORDER_BEING_PROCESSED: 'order being processed',
    COMPLETED: 'completed',
  },
  PATH: {
    TRACK_ORDER: '/track-order/',
    ORDER_DETAILS: '/order-details/',
    ADD_PICKUP: '/add-pickup/',
  },
};

export default ORDERDETAILS_CONSTANTS;
